// extracted by mini-css-extract-plugin
export var changeIcon = "_3q-4";
export var container = "_3q-0";
export var divider = "_3q-7";
export var externalLinkIcon = "_3q-1";
export var green = "_3q-5";
export var helpCircleIcon = "_3q-3";
export var iconButton = "_3q-2";
export var red = "_3q-6";